import React, {useState} from "react";
import Wrp from '../../../../hoc/Wrp/Wrp';
// import MainMenuComponent from './MainMenuComponent';
import {fileNameShortenForDisplay,parameterizedURLAccessToken, formatBytes} from '../../../../Utils/CommonFunctions';
import moment from 'moment';
// import ReplyToMail from '../../ComposeMail/ReplyToMail';
// import ComposeMail from '../../ComposeMail';
// import Icons from "../../../../Components/Icons/Icons";

const DetailMessage = (props) => {
    const {emailData,indexLoop,hideShow} = props;
    //console.log(emailData, 'DetailMessage')
    let msgDate = moment(emailData.created_at).format('DD MMM, hh:mm A');
    let messageLoopID = 'Div_'+indexLoop
    let totalSize = 0;
    if(emailData.files) {
        emailData.files.forEach((item,ind) => {
            totalSize += item.size;
        })
    }
    //console.log(hideShow, 'hideShow')
    let stripedBody = '';
        if(emailData.body !==  undefined){
     stripedBody = emailData.body.replace(/<(.|\n)*?>/g, '');
    //stripedBody = stripedBody.replace('&nbsp;', ' ');
    stripedBody = stripedBody.replace(/&nbsp;/g, ' ');
    stripedBody = stripedBody.substring(0,150);
}
    //remove html tags from a string, leaving only the inner text
    function removeHTML(str){ 
        let tmp = document.createElement("DIV");
        tmp.innerHTML = str;
        return tmp.textContent || tmp.innerText || "";
        //return str;
    }

    function removeHTMLStyle(str){
        //console.log(str, 'str')
        if(str.includes('<style')){
            let s1 = str.split("<style")[0];            
            let s2 = str.split("</style>");
            //console.log(s2[0], 's2')
            //console.log(s2.length, 's2.length')
            return str = s1 + s2[s2.length-1];   
        }else{
            return str;
        }
          
    }

    //let stripedHtml = emailData.body.replace(/<style.*<\/style>/g, '');
    function isHTML(str) {
        var doc = new DOMParser().parseFromString(str, "text/html");
        return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
    }
    let stripedHtml = '';
        if(emailData.body !==  undefined){
     stripedHtml = removeHTMLStyle(emailData.body);
    //let stripedHtml = emailData.body.replace(/<[^>]+>/g, '');
    stripedHtml = stripedHtml.replace(/<[^>]+>/g, '');
    stripedHtml = removeHTML(stripedHtml);
    stripedHtml = stripedHtml.substring(0,250);
    //console.log(stripedHtml, 'stripedHtml')
}
   let stripedHtmlFull ='';
    if (emailData.body !== undefined){
        stripedHtmlFull = emailData.body;
    }
    //  stripedHtmlFull = removeHTMLStyle(emailData.body);
    
    //style tag allowed because email body display is not same as mail received or send , we used iframe to avoid css conflicts
   


    let isHtmlBody = isHTML(stripedHtmlFull);
    //let stripedHtmlFull = emailData.body;
    // console.log(emailData.to,emailData.to.length);

    const [mailType,setMailType] = useState('outer');
    const showMailDetails = (clickType,indexLoop) => {
        //console.log('showMailDetails',clickType)
        if(clickType === 'inner'){
            return false;
        }
        if(clickType === 'outer'){
            props.showDivMessageHandler(indexLoop)    
        }        
    }

    return(
        <Wrp>

        


        <div className="email-sender p-2 cursor-pointer" onClick={e => { e.stopPropagation(); showMailDetails('outer',indexLoop); }}>
            <div className="avatar">
                <img src="/assets/img/profile2.jpg" alt="Avatar" />
            </div>
            <div className="sender cursor-pointer pr-2 w-70">    
                <div className="from text-medium"> {emailData.from} <span className="third_light_color text-small"><span aria-hidden="true">&lt;</span>{emailData.from}<span aria-hidden="true">&gt;</span></span> 
                </div> 

                {
                    hideShow === 'show' ?
                    <>
                        <span className="text-small third_light_color"> to {emailData.to ? emailData.to.map(t => <span>{t}</span>).reduce((prev, curr) => [prev, ', ', curr]) : null} </span>
                        <div className="action ml-1 show" onClick={e => { e.stopPropagation(); showMailDetails('inner',indexLoop); }}>
                            <a data-toggle="dropdown" className="dropdown-toggle" aria-expanded="true"></a>
                            <div role="menu" className="dropdown-menu dropdown-user animated fadeIn ">
                                <div className=" ">
                                    <div className="d-flex align-items-center mb-2">
                                        <div className="text-muted text-medium p-0 col-3 text-right"> From : </div>
                                        <div className="secondary_color text-medium text-bold pl-2"> {emailData.from} </div>
                                    </div>

                                    <div className="d-flex align-items-center mb-2">
                                        <div className="text-muted text-medium p-0 col-3 text-right"> To : </div>
                                        <div className="secondary_color text-medium text-bold pl-2"> {emailData.to ? emailData.to.map(t => <span>{t}</span>).reduce((prev, curr) => [prev, ', ', curr]) : null} </div>
                                    </div>

                                    {
                                        emailData.cc?
                                        <div className="d-flex align-items-center mb-2">
                                            <div className="text-muted text-medium p-0 col-3 text-right"> Cc : </div>
                                            <div className="secondary_color text-medium text-bold pl-2"> {emailData.cc ? emailData.cc.map(t => <span>{t}</span>).reduce((prev, curr) => [prev, ', ', curr]) : null} </div>
                                        </div>
                                        :
                                        <></>
                                    }
                                    

                                    {
                                        props.emailName === 'outbox' && emailData.bcc?
                                        <div className="d-flex align-items-center mb-2">
                                            <div className="text-muted text-medium p-0 col-3 text-right"> Bcc : </div>
                                            <div className="secondary_color text-medium text-bold pl-2"> {emailData.bcc ? emailData.bcc.map(t => <span>{t}</span>).reduce((prev, curr) => [prev, ', ', curr]) : null} </div>
                                        </div>
                                        :
                                        <></>
                                    }
                                    

                                    <div className="d-flex align-items-center mb-2">
                                        <div className="text-muted text-medium p-0 col-3 text-right"> Subject : </div>
                                        <div className="secondary_color text-medium text-bold pl-2">  {emailData.subject} </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                    :
                    <div>
                    <p className="msg">
                        {/*<span dangerouslySetInnerHTML={{ __html: stripedBody }}></span>*/}
                        <span dangerouslySetInnerHTML={{ __html: stripedHtml }}></span>
                    </p>
                    </div>
                }                             
            </div>
            <div className="date"> 
                <span className="pr-3 text-small"> {msgDate} </span> 
                {
                    hideShow === 'show' ? 
                    <Wrp>
                        <span onClick={e=>props.replyToMailHandler(emailData)} className="pr-3 cursor-pointer"> 
                            <i title="Reply" className="fas fa-reply fa-lg"></i> 
                        </span>
                        {emailData.to && emailData.to.length > 1 ?
                        <span onClick={e=>props.replyToMailHandler(emailData,true)} className="pr-3 cursor-pointer"> 
                            <i title="Reply All" className="fas fa-reply-all fa-lg"></i> 
                        </span> : null}
                    </Wrp> : null
                }                                
            </div>
        </div>
        <div className={`email-body pb-0 ${hideShow}`} id={messageLoopID}>
            <div className="mailBodycontent">
            {(isHtmlBody)?<iframe sandbox='allow-scripts allow-popups'    srcDoc={stripedHtmlFull} />:<pre dangerouslySetInnerHTML={{ __html: stripedHtmlFull }} />}
                {/* <span    dangerouslySetInnerHTML={{ __html: sanitize(stripedHtmlFull) }} /> */}
            </div> 

            {
                emailData.files && emailData.files.length > 0 ?
                <div className="email-attachments border-bottom">
                    <div className="title">Attachments 
                        <span className="pl-1">({emailData.files.length} files {formatBytes(totalSize)})</span>
                    </div>
                    <ul>
                    {
                        emailData.files ? emailData.files.map((itemFile,index)=>{
                            let imagePath = '/assets/img/noimage.png';
                            if(itemFile.id!==''){
                                imagePath = parameterizedURLAccessToken('files/download?fileId='+itemFile.id)
                            }
                            const itemFileLabel = fileNameShortenForDisplay(itemFile.label);

                            const ext = itemFile.label.split('.').pop();
                            let fileIcon = 'fas fa-file';
                            let roundedClass = '';                                          
                            if(ext==='pdf'){
                               fileIcon = 'fas fa-file-pdf';
                               roundedClass = 'bg-danger';
                            }else if(ext==='doc' || ext==='docx'){
                               fileIcon = 'far fa-file-word';
                               roundedClass = 'bg-info';
                            }else if(ext==='xls' || ext==='xlsx'){
                               fileIcon = 'far fa-file-excel';
                               roundedClass = ' bg-success';
                            }else if ((itemFile.label).match(/.(jpg|jpeg|png|gif)$/i)){
                               fileIcon = 'fas fa-file-image-o';
                               roundedClass = ' bg-success';
                            }

                            return(
                                <li key={index}><a onClick={e=>props.callDownloadImgFile(this,itemFile)}><i className="fa fa-paperclip"></i> {itemFileLabel} <span>({formatBytes(itemFile.size)})</span></a></li>
                            )
                        }) : null
                    }
                    </ul>
                </div>
                :
                ''
            }

            
        </div>
        
        
        
        </Wrp>
    )
}

export default DetailMessage;